
export type StatusFormBlock = "complete" | "edit";
export type TypeForm = "create" | "edit";

export const PROVIDER_STATUS_VALUES = {
  ACTIVE: "active",
  ACTIVE_ACH: "active-ach",
  ACTIVE_CHECK: "active-check",
  COMPLETE: "Complete",
  COMPLETED: "completed",
  DEACTIVATED: "deactivated",
  DRAFT: "draft",
  ENROLLED_ACH: "enrolled_ach",
  ENROLLED_CHECK: "enrolled_check",
  ENROLLED_VCC: "enrolled_vcc",
  FAILED: "failed",
  NEEDS_APPROVAL: "needs_approval",
  PENDING: "pending",
  PROCESSED: "processed",
  PROCESSING: "processing",
  PROGRESS: "in progress",
  REVIEW: "in_review",
  REACTIVATE: "reactivate",
} as const;

export const REMITTANCE_TYPE_VALUES = {
  ELECTRONIC: "electronic",
  PAPER: "paper",
} as const;

export const PAYMENT_TYPE_VALUES = {
  ACH: "ach",
  CHECK: "check",
  VCC: "vcc",
} as const;

export const PAYMENT_TYPE_LABELS = {
  [PAYMENT_TYPE_VALUES.ACH]: "ACH",
  [PAYMENT_TYPE_VALUES.CHECK]: "Check",
  [PAYMENT_TYPE_VALUES.VCC]: "VCC",
} as const;

export const REMITTANCE_TYPE_LABELS = {
  [REMITTANCE_TYPE_VALUES.ELECTRONIC]: "Electronic",
  [REMITTANCE_TYPE_VALUES.PAPER]: "Paper",
} as const;

export const STATUS_LABELS = {
  [PROVIDER_STATUS_VALUES.COMPLETED]: "Completed",
  [PROVIDER_STATUS_VALUES.DEACTIVATED]: "Deactivated",
  [PROVIDER_STATUS_VALUES.ACTIVE_ACH]: "Active - ACH",
  [PROVIDER_STATUS_VALUES.ACTIVE_CHECK]: "Active - Check",
  [`${PROVIDER_STATUS_VALUES.ACTIVE}_${PAYMENT_TYPE_VALUES.ACH}`]: "Active - ACH",
  [`${PROVIDER_STATUS_VALUES.ACTIVE}_${PAYMENT_TYPE_VALUES.CHECK}`]: "Active - Check",
  [`${PROVIDER_STATUS_VALUES.ACTIVE}_${PAYMENT_TYPE_VALUES.VCC}`]: "Active - VCC",
  [PROVIDER_STATUS_VALUES.DRAFT]: "Draft",
  [PROVIDER_STATUS_VALUES.FAILED]: "Failed",
  [PROVIDER_STATUS_VALUES.PENDING]: "Pending",
  [PROVIDER_STATUS_VALUES.PROCESSED]: "Processed",
  [PROVIDER_STATUS_VALUES.PROCESSING]: "Processing",
  [PROVIDER_STATUS_VALUES.PROGRESS]: "In Progress",
  [PROVIDER_STATUS_VALUES.NEEDS_APPROVAL]: "Needs Approval",
  [PROVIDER_STATUS_VALUES.REVIEW]: "In Review",
} as const;

export const PROVIDER_NETWORK_STATUS_VALUES = {
  ACTIVE: "active",
  ACTIVE_ACH: "active-ach",
  ACTIVE_CHECK: "active-check",
  COMPLETE: "Complete",
  COMPLETED: "completed",
  DEACTIVATED: "deactivated",
  DRAFT: "draft",
  ENROLLED_ACH: "enrolled_ach",
  ENROLLED_CHECK: "enrolled_check",
  ENROLLED_VCC: "enrolled_vcc",
  FAILED: "failed",
  NEEDS_APPROVAL: "needs_approval",
  PENDING: "pending",
  PROCESSED: "processed",
  PROCESSING: "processing",
  PROGRESS: "in progress",
  REVIEW: "in review",
  REACTIVATE: "reactivate",
};

export const PROVIDER_NETWORK_STATUS = [
  PROVIDER_NETWORK_STATUS_VALUES.ACTIVE,
  PROVIDER_NETWORK_STATUS_VALUES.DEACTIVATED,
  PROVIDER_NETWORK_STATUS_VALUES.REVIEW,
  PROVIDER_NETWORK_STATUS_VALUES.DRAFT,
  PROVIDER_NETWORK_STATUS_VALUES.NEEDS_APPROVAL,
] as const;

export type ProviderStatus = (typeof PROVIDER_NETWORK_STATUS)[number];
